'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/header'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('./common/pyFormElements'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./common/globalToast'));
    processInclude(require('./einsteinCarousel'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./loginPopup'));
    processInclude(require('./common'));
    processInclude(require('./storeLocator/storeLocator'));
    processInclude(require('./common/customDropdown'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/deliveryAvailabilityModal'));
    processInclude(require('./checkout/shippingAddress'));
    processInclude(require('./downloadCatalogue'));
    processInclude(require('./tryItOn'));
    processInclude(require('./savingSchemes'));
    processInclude(require('./payU/initializePayUButton'));
});

require('base/thirdParty/bootstrap');
require('./thirdParty/bootstrap-datepicker');
require('./components/spinner');
require('slick-carousel');
